import { CustomListItemId, LocationSearchMatchType } from "@sp-crm/core";
import { SearchGeoParams } from "generated/graphql";

export interface ClientMapSearchParams {
    searchString: string | null;
    searchType: "bestName" | "anyName" | "phone";
    assignedUserId: string | null;
    statusListItemIds: CustomListItemId[];
    geoParams: SearchGeoParams | null;
}

const LOCATION_SEARCH_MATCH_TYPES = [
    "zip",
    "city",
    "distance",
    "county",
    "state",
] as const;

const isLocationSearchMatchType = (value: string): value is LocationSearchMatchType =>
    (LOCATION_SEARCH_MATCH_TYPES as readonly string[]).includes(value);

export interface GeoParamsInput {
    address?: string | null;
    zip?: string | null;
    city?: string | null;
    county?: string | null;
    state?: string | null;
    distance?: number | null;
    matchType?: LocationSearchMatchType | null;
    coordinates?: { lat: string; lng: string } | null;
    bounds?: {
        northWest: { lat: string; lng: string };
        southEast: { lat: string; lng: string };
    } | null;
}

export function clearBoundsFromGeoParams(
    geoParams: SearchGeoParams | null,
): SearchGeoParams | null {
    if (!geoParams) {
        return null;
    }
    if (!geoParams.matchType) {
        return null;
    }
    return { ...geoParams, bounds: null };
}

export function toGeoParamsInput(
    geoParams: SearchGeoParams | null,
): GeoParamsInput | null {
    if (!geoParams) {
        return null;
    }
    return {
        address: geoParams.address,
        zip: geoParams.zip,
        city: geoParams.city,
        county: geoParams.county,
        state: geoParams.state,
        distance: geoParams.distance,
        matchType:
            geoParams.matchType && isLocationSearchMatchType(geoParams.matchType)
                ? geoParams.matchType
                : null,
        coordinates: geoParams.coordinates
            ? { lat: geoParams.coordinates.lat, lng: geoParams.coordinates.lng }
            : null,
        bounds: geoParams.bounds
            ? {
                  northWest: {
                      lat: geoParams.bounds.northWest.lat,
                      lng: geoParams.bounds.northWest.lng,
                  },
                  southEast: {
                      lat: geoParams.bounds.southEast.lat,
                      lng: geoParams.bounds.southEast.lng,
                  },
              }
            : null,
    };
}
